import { render, staticRenderFns } from "./PublicUploader.vue?vue&type=template&id=62a494e0&scoped=true&"
import script from "./PublicUploader.vue?vue&type=script&lang=js&"
export * from "./PublicUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a494e0",
  null
  
)

export default component.exports